import styled from 'styled-components';

const SiteHeaderRightWrapper = styled.div`
   flex-basis: 100%;
   display: flex;
   justify-content: flex-end;
`;

export { SiteHeaderRightWrapper };
